<template>
  <div>
    <v-breadcrumbs
        divider=">"
        :items="items"
    >
      <template v-slot:item="{ item }">
        <v-btn text color="primary" :disabled="item.disabled" @click="handleBreadcrumbs(item.href)"
               style="padding: 0; height: auto"
        >{{item.text}}</v-btn>
      </template>
    </v-breadcrumbs>
    <div style="background-color: #F5F5F5">
      <div v-if="!contract.recordId">
        <v-dialog v-model="close.dialog" max-width="500px" v-if="_hasButtonPermission('终止合同')">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="primary"
                depressed
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                :disabled="contract.status == 8 || contract.status == 9 || new Date(Date.parse(contract.endDate)) <= new Date()"
            >
              合同终止
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">合同终止</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                      cols="12"
                      sm="12"
                      md="12"
                  >
                    <date-picker label="终止日期" v-model="close.closeDate" :rules="[rules.required]"></date-picker>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="blue darken-1"
                  text
                  @click="close.dialog = false"
              >
                取消
              </v-btn>
              <v-btn
                  color="blue darken-1"
                  text
                  @click="closeSave"
              >
                确定
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="move.dialog" max-width="500px" v-if="_hasButtonPermission('移交合同')">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="primary"
                depressed
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                :disabled="contract.status == 8 || contract.status == 9 || !!contract.storeId"
            >
              合同移交
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">合同移交</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="moveForm">
              <v-container>
                <v-row>
                  <v-col
                      cols="12"
                  >
                    <store-select label="签约门店" v-model="move.storeId" :rules="[rules.required]"></store-select>
                  </v-col>
                  <v-col cols="12">
                    <oa-user-select label="计提提报人" v-model="move.oaUser" :rules="[rules.required]"></oa-user-select>
                  </v-col>
                  <v-col cols="12">
                    <oa-user-select label="付款提报人" v-model="move.payOaUser" :rules="[rules.required]"></oa-user-select>
                  </v-col>
                </v-row>
              </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="blue darken-1"
                  text
                  @click="move.dialog = false"
              >
                取消
              </v-btn>
              <v-btn
                  color="blue darken-1"
                  text
                  @click="moveSave"
              >
                确定
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <v-card class="ma-2" elevation="0">
        <v-card-title>合同基础信息</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="3">
              <v-text-field label="合同状态" disabled outlined dense :value="contract.statusName"></v-text-field>
            </v-col>
            <v-col cols="3" v-if="contract.status == 9">
            <v-text-field label="终止日期" disabled outlined dense :value="contract.closeDate"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field label="合同阶段" disabled outlined dense :value="contract.storeId?'门店合同':'拓展合同'"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field label="关联合同" disabled outlined dense :value="contract.linkContractInfo?contract.linkContractInfo.contractCode+'(' + contract.linkContractInfo.projectName + ')':''"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field label="项目名称" disabled outlined dense :value="contract.projectName"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field label="系统合同号" disabled outlined dense :value="contract.contractId"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field label="物理合同号" disabled outlined dense :value="contract.contractCode"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field label="合同类型" disabled outlined dense :value="contract.typeName"></v-text-field>
            </v-col>
            <v-col cols="3">
              <nc-corp-select label="签约公司" disabled :value="contract.unitcode" ></nc-corp-select>
            </v-col>
            <v-col cols="3">
              <nc-dept-select label="承担部门" disabled :value="contract.voucherDept" :unitcode="contract.unitcode"></nc-dept-select>
            </v-col>
            <v-col cols="3">
              <v-text-field label="已登记客商" disabled outlined dense :value="contract.merchantsId + contract.merchantsName"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field label="银行账户" disabled outlined dense :value="merchantsAccount.bankName + ' ' + merchantsAccount.account"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field label="合同起止日期" disabled outlined dense :value="contract.startDate +' ~ ' + contract.endDate"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field label="免租天数" disabled outlined dense :value="contract.rentFreeDays"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field label="免租说明" disabled outlined dense :value="contract.rentFreeExplain"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field label="签约人" disabled outlined dense :value="contract.contractor"></v-text-field>
            </v-col>
            <v-col cols="3" v-if="contract.storeId">
              <v-text-field label="签约门店" disabled outlined dense :value="contract.storeName" ></v-text-field>
            </v-col>

          </v-row>
          <v-row>
            <v-col cols="6">
              <v-textarea
                  outlined
                  disabled
                  label="备注"
                  :value="contract.remark"
              ></v-textarea>
            </v-col>
            <v-col cols="6" v-if="contract.recordId">
              <v-textarea
                  outlined
                  disabled
                  label="变动说明"
                  :value="contract.updateDescription"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1">附件：</v-col>
            <v-col cols="2" v-for="(file, i) in contract.attachList" :key="i">
              <a :href="file.url">{{file.fileName}}</a>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="ma-2" elevation="0">
        <v-card-title>费用明细</v-card-title>
        <v-card-text>
          <v-row align="center" justify="space-around">
            <label class="text-h6">费用总金额</label>
            <label class="text-h6">已付金额</label>
            <label class="text-h6">已计提金额</label>
          </v-row>
          <v-row align="center" justify="space-around">
            <label class="text-subtitle-1">{{ textFormat(contract.totalPrice/100,'#,##0.00') }}</label>
            <label class="text-subtitle-1">{{ textFormat(contract.paidPrice/100,'#,##0.00') }}</label>
            <label class="text-subtitle-1">{{ textFormat(contract.accuralPrice/100,'#,##0.00') }}</label>
          </v-row>
          <v-row class="mt-4">
            <v-simple-table dense style="width: 2000px" class="mb-2">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left" width="100">编号</th>
                  <th class="text-center" width="100">费用类型</th>
                  <th class="text-center" width="200">开始日期~结束日期</th>
                  <th class="text-center" width="100">含税金额</th>
                  <th class="text-center" width="100">税率</th>
                  <th class="text-center" width="100">面积</th>
                  <th class="text-center" width="100">分期金额</th>
                  <th class="text-center" width="100">计算方式</th>
                  <th class="text-center" width="100">收费规则</th>
                  <th class="text-center" width="100">收费周期</th>
                  <th class="text-center" width="100">支付时点</th>
                  <th class="text-center" width="100">提成比率</th>
                  <th class="text-center" width="100">基数1</th>
                  <th class="text-center" width="100">比率1</th>
                  <th class="text-center" width="100">基数2</th>
                  <th class="text-center" width="100">比率2</th>
                  <th class="text-center" width="100">基数3</th>
                  <th class="text-center" width="100">比率3</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(cost,i) in contract.costList" :key="i">
                  <td><div style="width: 30px">{{i+1}}</div></td>
                  <td><div style="width: 80px" class="text-center">{{cost.costName}}</div></td>
                  <td><div style="width: 180px" class="text-center">{{cost.startDate}} ~ {{cost.endDate}}</div></td>
                  <td><div style="width: 80px" class="text-center">{{textFormat(cost.price / 100,'#,##0.00')}}</div></td>
                  <td><div style="width: 50px" class="text-center">{{cost.taxRate}}%</div></td>
                  <td><div style="width: 80px" class="text-center">{{cost.area}}</div></td>
                  <td><div style="width: 80px" class="text-center">{{textFormat(cost.periodPrice / 100,'#,##0.00')}}</div></td>
                  <td><div style="width: 100px" class="text-center">{{methodList[cost.method - 1].name}}</div></td>
                  <td><div style="width: 80px" class="text-center">{{ruleList[cost.rule - 1].name}}</div></td>
                  <td><div style="width: 80px" class="text-center">每{{cost.periodMonth}}月</div></td>
                  <td><div style="width: 80px" class="text-center">{{cost.payDay}}号</div></td>
                  <td><div style="width: 80px" class="text-center">{{cost.percentageRate}}%</div></td>
                  <td><div style="width: 50px" class="text-center">{{cost.base1/100}}</div></td>
                  <td><div style="width: 50px" class="text-center">{{cost.rate1}}%</div></td>
                  <td><div style="width: 50px" class="text-center">{{cost.base2/100}}</div></td>
                  <td><div style="width: 50px" class="text-center">{{cost.rate2}}%</div></td>
                  <td><div style="width: 50px" class="text-center">{{cost.base3/100}}</div></td>
                  <td><div style="width: 50px" class="text-center">{{cost.rate3}}%</div></td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="ma-2" elevation="0">
        <v-card-title>定金/保证金</v-card-title>
        <v-card-text>
          <v-simple-table dense class="mb-2">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center" width="100">性质</th>
                <th class="text-center" width="100">金额</th>
                <th class="text-center" width="100">生成日期</th>
                <th class="text-center" width="100">是否抵充租金</th>
                <th class="text-center" width="100">核销人</th>
                <th class="text-center" width="100">核销时间</th>
                <th class="text-center" width="100">操作</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(deposit,i) in contract.depositList" :key="i">
                <td class="text-center">{{depositTypeList[deposit.depositType -1].name}}</td>
                <td class="text-center">{{textFormat(deposit.price / 100,'#,##0.00')}}</td>
                <td class="text-center">{{deposit.payDate}}</td>
                <td class="text-center">{{deposit.isReplace?'是':'否'}}</td>
                <td class="text-center">{{deposit.status == 2?deposit.checkName:'/'}}</td>
                <td class="text-center">{{deposit.status == 2?deposit.checkTime:'/'}}</td>
                <td ><v-btn text color="primary" small :disabled="contract.statusName!='进行中'" v-if="(!contract.recordId && deposit.depositType == 2 && deposit.status != 2) && _hasButtonPermission('核销保证金')" @click="checkDeposit(deposit)" >核销</v-btn></td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <v-card class="ma-2" elevation="0">
        <v-card-title>分期明细</v-card-title>
        <v-card-text>
          <v-simple-table dense class="mb-2">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left" width="60">编号</th>
                <th class="text-left" width="100">费用类型</th>
                <th class="text-left" width="120">所属费用编号</th>
                <th class="text-left" width="100">计提金额</th>
                <th class="text-left" width="200">分期起止日期</th>
                <th class="text-left" width="100">应付金额</th>
                <th class="text-left" width="100">抵充金额</th>
                <th class="text-left" width="100">实际金额</th>
                <th class="text-left" width="100">应付日期</th>
                <th class="text-left" width="150">付款状态</th>
                <th class="text-left" width="150">计提状态</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(period,i) in contract.periodList" :key="i">
                <td>{{i+1}}</td>
                <td>{{ period.costName }}</td>
                <td>{{ period.costIndex + 1 }}</td>
                <td>{{ textFormat(period.price / 100,'#,##0.00')}}</td>
                <td>{{ period.startDate }}~{{ period.endDate }}</td>
                <td>{{ textFormat(period.duePrice/100,'#,##0.00')}}</td>
                <td>{{ textFormat(period.replacePrice / 100, '#,##0.00')}}</td>
                <td>{{ textFormat(period.actualPrice?period.actualPrice/100:(period.method == 1?(period.duePrice - period.replacePrice)/100:'/'), '#,##0.00')}}</td>
                <td>{{ period.payDate}}</td>
                <td>{{payStatusList[period.payStatus -1].name}}
                    <v-btn depressed small text color="primary"
                           v-if="!contract.recordId && (period.payStatus == 1 || period.payStatus == 4) && (period.actualPrice || period.method == 1)" @click="pushOa(period,2)"
                    >推送OA</v-btn>
                </td>
                <td>{{accuralStatusList[period.accuralStatus-1].name}}
                  <v-btn depressed small text color="primary"
                         v-if="!contract.recordId && (period.accuralStatus == 1 || period.accuralStatus == 4) && (period.method == 1)" @click="pushOa(period, 1)"
                  >推送OA</v-btn>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <v-card class="ma-2" elevation="0" v-if="!contract.recordId">
        <v-card-title><label class="mr-2">关联人信息</label>
          <v-btn
              color="primary"
              depressed
              class="mr-2"
              :disabled="contract.status == 8 || contract.status == 9"
              @click="savePerson"
              v-if="_hasButtonPermission('保存关联人信息')"
          >
            保存
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="personForm">
          <v-card elevation="0">
            <v-card-title>计提OA提报人</v-card-title>
            <v-card-text>
              <v-col cols="3" class="pa-0">
                <oa-user-select v-model="oaUser" :rules="[rules.required]"></oa-user-select>
              </v-col>

            </v-card-text>
          </v-card>
            <v-card elevation="0">
              <v-card-title>付款OA提报人</v-card-title>
              <v-card-text>
                <v-col cols="3" class="pa-0">
                  <oa-user-select v-model="payOaUser" :rules="[rules.required]"></oa-user-select>
                </v-col>

              </v-card-text>
            </v-card>
          <v-card elevation="0">
            <v-card-title>预警接收人</v-card-title>
            <v-card-text>
              <v-simple-table dense class="mb-2">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-center" width="100">姓名</th>
                    <th class="text-center" width="150">手机号</th>
                    <th class="text-left" width="1000">操作</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(warning,i) in contract.warningList" :key="i">
                    <td><v-text-field dense outlined style="width: 100px"  v-model="warning.name" :rules="[rules.required]"></v-text-field></td>
                    <td><v-text-field dense outlined style="width: 150px"  v-model="warning.mobile" :rules="[rules.required, rules.mobile]" ></v-text-field></td>
                    <td><v-btn text color="primary" class="pa-0" @click="deleteWarning(i)" :disabled="contract.status == 8 || contract.status == 9">删除</v-btn></td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-btn block depressed outlined color="primary" @click="addWarning" :disabled="contract.status == 8 || contract.status == 9">
                添加
              </v-btn>
            </v-card-text>
          </v-card>
          </v-form>
        </v-card-text>
      </v-card>
      <v-card class="ma-2" elevation="0" v-if="!contract.recordId && contract.tempList && contract.tempList.length > 0">
        <v-card-title>临时费用明细</v-card-title>
        <v-card-text>
          <v-simple-table dense class="mb-2">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left" width="100">编号</th>
                <th class="text-left" width="100">费用类型</th>
                <th class="text-left" width="100">应付日期</th>
                <th class="text-left" width="200">分期日期</th>
                <th class="text-left" width="100">含税金额</th>
                <th class="text-left" width="100">税率</th>
                <th class="text-left" width="100">付款状态</th>
                <th class="text-left" width="100">计提状态</th>
                <th class="text-left" width="150">备注</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(temp,i) in contract.tempList" :key="i">
                <td>{{i+1}}</td>
                <td>{{ temp.costName }}</td>
                <td>{{ temp.payDate }}</td>
                <td>{{ temp.startDate}} ~ {{temp.endDate}}</td>
                <td>{{ textFormat(temp.price / 100, '#,##0.00')}}</td>
                <td>{{ temp.taxRate }} % </td>
                <td>{{payStatusList[temp.payStatus -1].name}}</td>
                <td>{{accuralStatusList[temp.accuralStatus-1].name}}</td>
                <td>{{temp.remark}}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import StoreSelect from "@/components/erp/contract/StoreSelect";
import NcDeptSelect from "@/components/erp/contract/NcDeptSelect";
import {default as ContractApi} from "@/api/erp/contract/ContractApi";
import OaUserSelect from "@/components/erp/contract/OaUserSelect";
import NcCorpSelect from "@/components/erp/contract/NcCorpSelect";
export default {
  name: "ContractView",
  components: {NcCorpSelect, OaUserSelect, NcDeptSelect, StoreSelect},
  props: {
    viewInfo:{
      type:Object
    },
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data(){
    return {
      //面包屑
      items: [
        {
          text: '合同管理',
          disabled: false,
          href: 'list',
        },
        {
          text: '合同查看',
          disabled: true,
          href: 'view',
        },
      ],
      rules:{
        required: value => (!!value || value === 0) || '必填.',
        int:value => ((!value && value != 0)||(!isNaN(parseInt(value)) && value > 0)) || '只能输入正整数',
        remark:value => (!value || value.length <= 200) || '最多只能200个字',
        number:value=> ((!value && value != 0)||(!isNaN(parseFloat(value)) && value > 0)) || '只能输入数字',
        month: value=> ((!value && value != 0)||(!isNaN(parseInt(value)) && value > 0 && value <= 12)) || '只能输入1-12的数字',
        day: value=> ((!value && value != 0)||(!isNaN(parseInt(value)) && value > 0 && value <= 31)) || '只能输入1-31的数字',
        mobile: value=> ((!value && value != 0)||(/^1[0-9]{10}$/.test(value))) || '请输入正确的手机号',
      },

      close:{
        dialog:false,
        closeDate:'',
      },
      move:{
        dialog:false,
        storeId:null,
        voucherDept: null,
        oaUser: {},
        payOaUser:{}
      },
      contract:{},
      methodList:[{id:1,name:'固定金额'},{id:2,name:'无保底纯扣点'},{id:3,name:'扣点取高'}],
      ruleList:[{id:1,name:'预付'},{id:2,name:'后付'},{id:3,name:'当月付'}],
      depositTypeList:[{id:1,name:'定金'},{id:2,name:'保证金'}],
      payStatusList:[{id:1,name:'未付款'},{id:2,name:'OA审批中'},{id:3,name:'已付款'},{id:4,name:'OA审批失败'}],
      accuralStatusList:[{id:1,name:'未计提'},{id:2,name:'已计提'},{id:3,name:'OA审批中'},{id:4,name:'OA审批失败'}],
      oaUser:{},
      payOaUser: {},
      merchantsAccount:{},
      defaultWarning:{
        name:null,
        mobile:null,
      },
    }
  },
  mounted(){
    Object.assign(this.contract,this.viewInfo);
    this.getContractInfo();
  },
  methods: {
    handleBreadcrumbs(href) {
      console.log(href);
      this.$emit("formCallback", href)
    },
    getContractInfo(){
      let me = this;
      if(this.contract.recordId){
        ContractApi.getChangeRecord({recordId:this.contract.recordId}).then(data=>{
            data.unitcode = data.voucherDept.substr(0,2);
            me.contract = data;

            me.items[1].text = "变更查看";

          if(me.contract.merchantsAccount){
            me.merchantsAccount = JSON.parse(me.contract.merchantsAccount);
          }
        })
      }else{
        ContractApi.getContract({contractId:this.contract.contractId}).then(data=>{
            data.unitcode = data.voucherDept.substr(0,2);
            me.contract = data;

            me.oaUser = JSON.parse(me.contract.oaUserName);
            me.payOaUser = JSON.parse(me.contract.payOaUserName);

          if(me.contract.merchantsAccount){
            me.merchantsAccount = JSON.parse(me.contract.merchantsAccount);
          }
          if(data.closeDate){
            me.close.closeDate = data.closeDate;
          }

        })
      }

    },
    addWarning(){
      let warning = Object.assign({}, this.defaultWarning);
      this.contract.warningList.push(warning);
    },
    deleteWarning(index){
      this.contract.warningList.splice(index,1);
    },
    closeSave(){
      if(!this.close.closeDate){
        this.$dialog.error({
          text:'请选择终止日期',
          title:'错误'
        })
        return
      }
      let closeDate = new Date(Date.parse(this.close.closeDate));
      let today = new Date();
      let endDate = new Date(Date.parse(this.contract.endDate));
      if(closeDate <= today){
        this.$dialog.error({
          text:'终止日期不可早于今天',
          title:'错误'
        })
        return
      }
      if(closeDate >= endDate){
        this.$dialog.error({
          text:'终止日期不可晚于合同结束日期',
          title:'错误'
        })
        return
      }
      let me = this;
      ContractApi.closeContract({contractId:this.contract.contractId, closeDate: this.close.closeDate}).then(data=>{
          me.getContractInfo();
          me.close.dialog = false;
          me.$dialog.info({
            text:'终止成功',
            title:'操作成功'
          })
      })
    },
    moveSave(){
      let formValid = this.$refs.moveForm.validate();
      if(formValid){
        if(!this.move.oaUser.id){
          this.$dialog.error({
            title:'错误',
            text:'请选择计提提报人'
          })
          return;
        }
        if(!this.move.payOaUser.id){
          this.$dialog.error({
            title:'错误',
            text:'请选择付款提报人'
          })
          return;
        }
        let me = this;
        ContractApi.moveContract({
          contractId:this.contract.contractId,
          storeId:this.move.storeId,
          voucherDept: this.move.voucherDept,
          oaUserId: this.move.oaUser.id,
          oaUserName: JSON.stringify(this.move.oaUser),
          payOaUserId: this.move.payOaUser.id,
          payOaUserName: JSON.stringify(this.move.payOaUser)
        }).then(data=>{
            me.getContractInfo();
            me.move.dialog = false;
            me.$dialog.info({
              text:'移交成功',
              title:'操作成功'
            })
        })
      }
    },
    savePerson(){
      let formValid = this.$refs.personForm.validate();
      if(formValid){
        if(!this.oaUser.id){
          this.$dialog.error({
            title:'错误',
            text:'请选择计提OA提报人'
          })
          return;
        }
        if(!this.payOaUser.id){
          this.$dialog.error({
            title:'错误',
            text:'请选择付款OA提报人'
          })
          return;
        }
        if(!this.contract.warningList || this.contract.warningList.length == 0){
          this.$dialog.error({
            title:'错误',
            text:'请添加预警接收人'
          })
          return;
        }

        this.contract.oaUserId = this.oaUser.id;
        this.contract.oaUserName = JSON.stringify(this.oaUser);
        this.contract.payOaUserId = this.payOaUser.id;
        this.contract.payOaUserName = JSON.stringify(this.payOaUser);
        let me = this;
        ContractApi.savePerson(this.contract).then(data=>{
            me.getContractInfo();
            me.$dialog.info({
              text:'保存成功',
              title:'操作成功'
            })
        })
      }
    },
    async checkDeposit(deposit) {
      let me = this;
      const res = await this.$dialog.confirm({
        title: '确认',
        text: '确定要核销此保证金吗？',
      });
      if (res == true) {
        ContractApi.checkDeposit({depositId: deposit.depositId}).then(data => {
            me.getContractInfo(me.contract.contractId);
            me.$dialog.info({
              title: '操作成功',
              text: '核销成功',
            })
        })
      }
    },
    _hasButtonPermission(name){
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton =false
      for(let i=0;i<buttonPriviledgeList.length;i++){
        if(buttonPriviledgeList[i].name==name){
          if(buttonPriviledgeList[i].hasPriviledge=='Y'){
            return true
          } else {
            return false
          }
        }
      }
      return false
    },
    async pushOa(period, type) {
      let date;
      if (type == 1) {  //计提
        let pushPrice = 0;
        this.contract.periodList.forEach(item=>{
          if(period.startDate.substr(0, 7) == item.startDate.substr(0, 7) && (item.accuralStatus == 1 || item.accuralStatus == 4)){
            pushPrice += item.price;
          }
        })

        var text = "是否推送" + period.startDate.substr(0, 7) + "此月的计提？<br/>预计推送金额:"+this.textFormat(pushPrice / 100,'#,##0.00')+"。<br/>此月的所有计提会一起推送，请勿重复点击！"
        date = period.startDate;
      } else if (type == 2) {
        let pushPrice = 0;
        this.contract.periodList.forEach(item=>{
          if(period.payDate == item.payDate && (item.payStatus == 1 || item.payStatus == 4)){
            pushPrice += item.actualPrice;
          }
        })

        text = "是否推送" + period.payDate + "此付款日期的付款？<br/>预计推送金额:"+this.textFormat(pushPrice / 100,'#,##0.00')+"。<br/>此付款日期的所有付款会一起推送，请勿重复点击！"
        date = period.payDate;
      }
      let res = await this.$dialog.confirm({
        title:'确认',
        text:text
      });
      if(res){
        let me = this;
        ContractApi.mendPush({contractId:period.contractId, pushDate:date, type:type}).then(data=>{
          me.getContractInfo(me.contract.contractId);
          me.$dialog.info({
            title: '操作成功',
            text: '补推成功',
          })
        })

      }
    }
  }
}
</script>

<style scoped>

</style>